import { useEffect, useState } from "react";

import { defaultAIFillSettings } from "@smart/bridge-types-basic";
import { EditableText } from "@smart/itops-sb-design-system-dom";

import { AIFillFileUpload } from "./ai-fill-file-upload";
import { baseLanguageKey, LanguageKey } from "../../../../types";
import { GqlForm, FormTranslation, UpdateAIFillSettings } from "../../types";

type AIFillSectionProps = {
  aiFillSettings: GqlForm["aiFillSettings"];
  updateAIFillSettings: UpdateAIFillSettings;
  viewingLanguage: LanguageKey;
  translations?: FormTranslation[] | null;
  disabled?: boolean;
};

export const AIFillSection = ({
  aiFillSettings,
  updateAIFillSettings,
  viewingLanguage,
  translations,
  disabled,
}: AIFillSectionProps) => {
  const isViewingBaseLanguage = viewingLanguage === baseLanguageKey;
  const formTranslation = !isViewingBaseLanguage
    ? translations?.find((t) => t.language === viewingLanguage)
    : undefined;

  const baseSectionTitle =
    aiFillSettings?.sectionTitle || defaultAIFillSettings.sectionTitle;
  const translatedSectionTitle = formTranslation?.aiFillSectionTitle;
  const displayedSectionTitle = isViewingBaseLanguage
    ? baseSectionTitle
    : translatedSectionTitle || baseSectionTitle;

  const [editingTitle, setEditingTitle] = useState(displayedSectionTitle);

  useEffect(() => {
    setEditingTitle(displayedSectionTitle);
  }, [displayedSectionTitle]);

  const forLanguage = isViewingBaseLanguage ? undefined : viewingLanguage;

  return (
    <div className="flex-1 bg-neutral-20 overflow-y-auto p-16">
      <div className="max-w-readable mx-auto mb-4">
        <EditableText
          dataTestId="ai-fill-section-title"
          text={editingTitle}
          onChange={setEditingTitle}
          onComplete={() =>
            updateAIFillSettings({ sectionTitle: editingTitle }, forLanguage)
          }
          fontSize="h3"
          fontWeight="semibold"
          disabled={disabled}
        />
      </div>
      <AIFillFileUpload
        aiFillSettings={aiFillSettings}
        updateAIFillSettings={updateAIFillSettings}
        viewingLanguage={viewingLanguage}
        formTranslation={formTranslation}
        disabled={disabled}
      />
    </div>
  );
};
